export const updatePasswordOptions = {
  props: ({mutate}) => ({
    updatePasswordMutation: variables =>
      mutate({
        variables
      })
  })
};
